export const socialMediasIcons = [
  { id: 1, icon: "logos:telegram", name: "telegram" },
  { id: 2, icon: "logos:facebook", name: "facebook" },
  { id: 3, icon: "skill-icons:instagram", name: "instagram" },
  { id: 4, icon: "logos:youtube-icon", name: "youtube" },
  { id: 5, icon: "logos:twitter", name: "twitter" },
];
